import React from "react";
import "../App.css";

export default function TournamentDetailsBanner() {
  return <section className="tournamentDetails" id="home"></section>;
}
